import styled from "styled-components";

export const AboutUsContainer = styled.div`
    width: min(92%, 1180px);
    margin: 60px auto 0;

    @media (max-width: 600px) {
        margin-top: 40px;
    }
`;

export const HeadContent = styled.div`
    display: grid;
    grid-template-columns: 1.2fr 1fr;
    gap: 40px;
    align-items: center;

    @media (max-width: 900px) {
        grid-template-columns: 1fr;
        gap: 28px;
    }
`;

export const ImageBlock = styled.div`
    display: flex;
    justify-content: center;

    img {
        width: 100%;
        height: auto;
        border-radius: var(--radius-xl);
        box-shadow: var(--shadow-md);
    }
`;

export const TextBlock = styled.div``;

export const AboutHead = styled.p`
    font-size: clamp(20px, 2.4vw, 28px);
    color: var(--color-text);
    font-weight: 700;
    margin: 0;
    line-height: 1.4;

    &::before {
        content: '';
        display: block;
        width: 50px;
        height: 4px;
        background: var(--color-primary);
        border-radius: 2px;
        margin-bottom: 22px;
    }
`;

export const MainTextBlock = styled.div`
    margin-top: 40px;
`;

export const AboutText = styled.p`
    font-size: 17px;
    font-weight: 400;
    line-height: 1.65;
    color: var(--color-text);
    margin: 0 0 18px;
`;

export const GreenBlock = styled.div`
    background: var(--color-primary-soft);
    border-left: 5px solid var(--color-primary);
    border-radius: var(--radius-lg);
    padding: 28px 32px;
    font-size: 18px;
    font-weight: 600;
    line-height: 1.6;
    color: var(--color-text);
    margin: 30px 0;

    @media (max-width: 600px) {
        padding: 22px 22px;
        font-size: 16px;
    }
`;
